const DEBUG = process.env.NODE_ENV === 'development';

export const log = {
  info: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log(message, ...args);
    }
  },
  warn: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.warn(message, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.error(message, ...args);
    }
  },
};

export function extractInitials(name: string) {
  const names = name.trim().split(' ');
  const firstName = names[0] ?? '';
  const lastName = names.length > 1 ? names[names.length - 1] : '';
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0);
}
